import { DashboardRoute } from '../types';
import PageNotFoundError from '../../views/pages/errors/PageNotFoundError';

export const pageNotFound = {
  path: '/dashboard/errors/page-not-found',
  component: PageNotFoundError,
} as DashboardRoute;

export default [
  pageNotFound,
];
